import ScrollReveal from "@/components/base/ScrollReveal";

export default function ForCompanies() {
  const clients = [
    "Supermercados", "Mercadinhos", "Hoteis", "Escolas", "Universidades",
    "Cafeterias", "Academias", "Lojas de conveniencia", "Empresas",
    "Refeitorios corporativos", "Eventos empresariais", "Compradores no atacado", "Revendedores",
  ];

  return (
    <section id="empresas" className="relative w-full py-20 md:py-28 bg-organic-cool overflow-hidden">
      <div className="relative w-full px-4 sm:px-6 md:px-10 lg:px-16 max-w-7xl mx-auto">
        <ScrollReveal className="text-center mb-14">
          <span className="inline-block text-xs font-semibold uppercase tracking-[0.2em] text-primary-600 mb-4">
            Para Empresas
          </span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-4">
            Seu negócio com a{" "}
            <span className="text-primary-600">qualidade Big Mania</span>
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto text-base md:text-lg">
            Seja para abastecer seu negócio ou oferecer alimentação de qualidade aos seus colaboradores e clientes, a Big Mania entrega praticidade, sabor e confiança.
          </p>
        </ScrollReveal>

        <ScrollReveal direction="up" delay={0.1} staggerChildren staggerDelay={0.04}>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 mb-12">
            {clients.map((client, idx) => (
              <div
                key={idx}
                className="flex items-center gap-2.5 px-4 py-3 rounded-xl bg-background-50/80 border border-background-200/40 card-glow transition-all duration-300 hover:-translate-y-0.5"
              >
                <i className="ri-building-4-line text-primary-500 shrink-0"></i>
                <span className="text-sm font-medium text-foreground-800">{client}</span>
              </div>
            ))}
          </div>
        </ScrollReveal>

        <ScrollReveal direction="up" delay={0.2}>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://wa.me/558534942701?text=Olá! Gostaria de me tornar um revendedor Big Mania."
              target="_blank"
              rel="noopener noreferrer"
              className="group inline-flex items-center justify-center gap-2 px-8 py-4 rounded-xl bg-primary-500 text-background-50 text-base font-semibold hover:bg-primary-600 transition-all duration-200 hover:-translate-y-0.5 cursor-pointer whitespace-nowrap shadow-xl shadow-primary-500/20"
            >
              <i className="ri-store-2-line text-lg"></i>
              Seja um Revendedor
              <i className="ri-arrow-right-up-line transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5"></i>
            </a>
            <a
              href="https://wa.me/558534942701?text=Olá! Gostaria de solicitar um orçamento para minha empresa."
              target="_blank"
              rel="noopener noreferrer"
              className="group inline-flex items-center justify-center gap-2 px-8 py-4 rounded-xl bg-background-50 border border-background-300 text-foreground-950 text-base font-semibold hover:bg-background-200 transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-file-list-3-line text-lg"></i>
              Solicitar Orçamento
            </a>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}